import { Wallet } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageBar = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div
      data-testid="language-bar"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 34,
        zIndex: 300,
        background: '#000000',
        borderBottom: '1px solid rgba(48,213,200,0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        gap: 6,
      }}
    >
      <a
        href="https://tokens.swarmbase.io"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="view-my-tokens-btn"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.05em',
          padding: '3px 12px',
          borderRadius: 4,
          color: '#30d5c8',
          border: '1px solid rgba(48,213,200,0.45)',
          background: 'rgba(48,213,200,0.08)',
          textDecoration: 'none',
          transition: 'background-color 0.2s ease, color 0.2s ease',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = '#30d5c8'; e.currentTarget.style.color = '#000000'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(48,213,200,0.08)'; e.currentTarget.style.color = '#30d5c8'; }}
      >
        <Wallet size={11} />
        {lang === 'ko' ? '내 토큰 보기' : 'View My Tokens'}
      </a>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 10, color: 'rgba(255,255,255,0.22)', letterSpacing: '0.2em', marginRight: 8 }}>
        LANGUAGE
      </span>
      {[
        { code: 'en', label: 'English' },
        { code: 'ko', label: '한국어' },
      ].map(({ code, label }) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-btn-${code}`}
          style={{
            fontFamily: code === 'ko' ? "'Noto Sans KR', sans-serif" : 'JetBrains Mono, monospace',
            fontSize: code === 'ko' ? 12 : 11,
            padding: '2px 12px',
            borderRadius: 4,
            background: lang === code ? '#30d5c8' : 'transparent',
            color: lang === code ? '#000000' : 'rgba(255,255,255,0.45)',
            border: `1px solid ${lang === code ? '#30d5c8' : 'rgba(255,255,255,0.12)'}`,
            cursor: 'pointer',
            letterSpacing: code === 'ko' ? 0 : '0.05em',
            transition: 'all 0.2s ease',
            fontWeight: lang === code ? 700 : 400,
          }}
          onMouseEnter={e => {
            if (lang !== code) {
              e.currentTarget.style.borderColor = 'rgba(48,213,200,0.4)';
              e.currentTarget.style.color = '#30d5c8';
            }
          }}
          onMouseLeave={e => {
            if (lang !== code) {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)';
              e.currentTarget.style.color = 'rgba(255,255,255,0.45)';
            }
          }}
        >
          {label}
        </button>
      ))}
      </div>
    </div>
  );
};

export default LanguageBar;
